/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import { useAtomValue } from 'jotai'
import Script from 'next/script'
import { useEffect } from 'react'

import { sessionAtom } from '@/store/session'

/** The part of the widget's global this component drives. Present only once the Zoho script has loaded. */
declare global {
  interface Window {
    $zoho?: {
      salesiq?: {
        visitor: {
          name: (name: string) => void
          email: (email: string) => void
          phone: (phone: string) => void
        }
      }
    }
  }
}

/**
 * Component responsible for loading the Zoho SalesIQ widget on the website.
 */
export const ZohoSalesIQ = () => {
  const sessionUser = useAtomValue(sessionAtom)
  const widgetCode = process.env.NEXT_PUBLIC_ZOHO_SALES_IQ_WIDGET_CODE
  const domain = process.env.NEXT_PUBLIC_ZOHO_SALES_IQ_DOMAIN

  /**
   * Supply the Zoho SalesIQ component with the user's session information if available.
   */
  useEffect(() => {
    updateZohoSalesIQ()
  }, [sessionUser])

  /**
   * Supply the Zoho SalesIQ component with the user's session information if available.
   */
  const updateZohoSalesIQ = () => {
    const visitor = typeof window !== 'undefined' ? window.$zoho?.salesiq?.visitor : undefined
    if (visitor && sessionUser) {
      visitor.name(`${sessionUser.firstName} ${sessionUser.lastName}`)
      visitor.email(sessionUser.email)

      if (sessionUser.phone) {
        visitor.phone(sessionUser.phone)
      }
    }
  }

  // Ensure widgetCode and domain are available
  if (!widgetCode || !domain) {
    console.warn('[Zoho SalesIQ]: Widget code or domain is not configured. Widget will not load.')
    return null
  }

  return (
    <Script
      id='zoho-salesiq-script'
      strategy='lazyOnload'
      src={`https://${domain}/widget?widgetcode=${widgetCode}&plugin_source=mta-website`}
      onError={(e) => {
        console.error('[Zoho SalesIQ]: Failed to load script: ', e)
      }}
      onLoad={() => updateZohoSalesIQ()}
    />
  )
}
